import { usePathname, useRouter } from "next/navigation";

import { serializeFilterSearchParams, useFilter } from "../use-filter";

import type { HouseCityParam } from "@/types";

const getQ = () => Math.random().toString(36).substring(7);

export const useActions = () => {
  const router = useRouter();
  const pathname = usePathname();
  const [searchParams, setSearchParam] = useFilter();

  const fetchData = async (page: HouseCityParam["pagina"]) => {
    const paramsSerialized = serializeFilterSearchParams({
      ...searchParams,
      pagina: page,
      q: getQ(),
    });

    router.push(`${pathname}${paramsSerialized}`, { scroll: true });
  };

  const cleanData = async () => {
    const paramsSerialized = serializeFilterSearchParams({
      pagina: 1,
      q: getQ(),
    });

    router.push(`${pathname}${paramsSerialized}`, { scroll: true });
  };

  const search = async () => {
    await fetchData(1);
  };

  const cleanSearch = async () => {
    const paramsSerialized = serializeFilterSearchParams({
      ...searchParams,
      pesquisa: null,
      pagina: 1,
      q: getQ(),
    });

    router.push(`${pathname}${paramsSerialized}`, { scroll: true });
  };

  return {
    state: searchParams,
    handler: {
      fetchData,
      cleanData,
      search,
      cleanSearch,
      setSearchParam,
    },
  };
};
